(function () {
    'use strict';

    function searchDataService($http) {
        var baseSearchUrl = '[BuildifyApiHost]/api/';

        function getQueryOptions(predicates, injectedPredicates, defaultPredicates) {
            var options = [];
            for (var key in predicates) {

                var predicate = predicates[key];
                var value = predicate.value;

                var matchingInjectedPredicate = injectedPredicates.find(function(matchingPredicate) {
                    return matchingPredicate.SearchFieldName === key;
                });

                if (matchingInjectedPredicate) {
                    if (Array.isArray(predicate.value)) {
                        if (Array.isArray(matchingInjectedPredicate.Value)) {
                            predicate.value = predicate.value.concat(matchingInjectedPredicate.Value);
                        }
                        else {
                            predicate.value.push(matchingInjectedPredicate.Value);
                        }
                    }

                    injectedPredicates.splice(injectedPredicates.indexOf(matchingInjectedPredicate), 1);
                }

                if (defaultPredicates) {
                    var matchingDefaultSearchPredicate = defaultPredicates.find(function (matchingPredicate) {
                        return matchingPredicate.SearchFieldName === key;
                    });

                    if (matchingDefaultSearchPredicate) {
                        if (matchingDefaultSearchPredicate.IsOverride) {
                            predicate.condition = matchingDefaultSearchPredicate.SearchCondition;
                            predicate.value = matchingDefaultSearchPredicate.Value;
                            value = predicate.value;
                        }
                        else {
                            if (Array.isArray(predicate.value)) {
                                if (Array.isArray(matchingDefaultSearchPredicate.Value)) {
                                    predicate.value = predicate.value.concat(matchingDefaultSearchPredicate.Value);
                                } else {
                                    predicate.value.push(matchingDefaultSearchPredicate.Value);
                                }
                            }
                        }

                        defaultPredicates.splice(defaultPredicates.indexOf(matchingDefaultSearchPredicate), 1);
                    }
                }

                var isNumber = !isNaN(parseFloat(value)) && isFinite(value);
                var isBool = typeof value === "boolean";
                var isArray = Array.isArray(value);
                if (predicate.watch != undefined) {
                    if (value && predicate.watch(value)) {
                        if (isNumber) {
                            processPredicate(key, predicate);
                        } else if (isBool) {
                            processPredicate(key, predicate);
                        } else if (isArray) {
                            predicate.value = predicate.value.join(',');
                            processPredicate(key, predicate);
                        } else if (value.length > 0) {
                            processPredicate(key, predicate);
                        }

                    }
                }
            }

            injectedPredicates.forEach(function(leftoverInjectedPredicate) {
                processPredicate(leftoverInjectedPredicate.SearchFieldName,
                {
                    value: leftoverInjectedPredicate.Value,
                    condition: leftoverInjectedPredicate.SearchCondition
                });
            });

            if (defaultPredicates) {
                defaultPredicates.forEach(function(leftoverDefaultPredicate) {
                    processPredicate(leftoverDefaultPredicate.SearchFieldName,
                        {
                            value: leftoverDefaultPredicate.Value,
                            condition: leftoverDefaultPredicate.SearchCondition
                        });
                });
            }

            function processPredicate(predictateKey, predicateObject) {
                options.push({
                    field: predictateKey,
                    value: predicateObject.value,
                    methodType: predicateObject.condition
                });
            }

            return options;
        }

        function getResults(queryModel) {
            var url = queryModel.entity ? (baseSearchUrl + queryModel.entity) : queryModel.uri;
            var body = {
                queryOptions: getQueryOptions(queryModel.predicates, queryModel.injectedPredicates, queryModel.defaultPredicates),
                pageSize: queryModel.pageSize,
                pageNumber: queryModel.pageNum,
                orderByField: queryModel.orderBy,
                orderByDirection: queryModel.orderByDirection,
                getAllResults: queryModel.getAllResults
            }
            return $http.post(url + '?' + (queryModel.additionalQueryString ? '&' + queryModel.additionalQueryString: ''),
                body).then(function (response) {
                    return response.data;
                });
        };

        return {
            getResults: getResults
        }
    }

    searchDataService.$inject = ['$http'];

    angular.module('ecap.common').service('searchDataService', searchDataService);
})();